export const isDateObject = (value: unknown): value is Date => {
  return (
    Object.prototype.toString.call(value) === '[object Date]' &&
    !isNaN(value as unknown as number)
  );
};
